export default "__VITE_ASSET__B0mLdHO0__"